import tw, { css, styled } from 'twin.macro'

import { Link } from 'gatsby'

export const HeroContainer = styled.section`
	${tw`flex flex-col md:flex-row w-full`}
`
export const ImageContainer = styled.img`
	${tw`xl:w-2/3 lg:w-2/3 md:w-2/3`}
	max-height: 500px;`

export const TextContainer = tw.div`w-full bg-blue-600 pr-0 xl:pr-32 pb-0 xl:pb-24 p-4 xl:p-16`
export const Category = tw.p`font-display uppercase text-white mb-4 text-sm`
export const Title = tw.h1`font-display text-2xl text-white mb-6 font-bold`
export const Description = tw.p`font-display text-white font-bold mb-4`

export const MainSection = styled.section`
	${tw`py-12 md:py-20 w-full`}
	background-color: #eeeeee;
`
export const StoriesSidebarContainer = tw.div`flex flex-col md:flex-row md:px-4 lg:w-11/12 xl:w-4/5 xxl:w-8/12 m-auto`
export const StoriesContainer = tw.div`flex flex-col w-full px-4`
export const Main = tw.div`w-full mb-4 lg:mb-32 bg-white`
export const MainTextContainer = tw.div`flex flex-col items-center p-3`
export const MainImageContainer = styled.div`
	${tw`overflow-hidden flex items-center justify-center cursor-pointer hover:opacity-75`}
	max-height: 550px;
`
export const StoryCategory = tw.p`font-display uppercase text-gray-800 tracking-widest mb-2`
export const MainTitle = tw.h3`font-display text-dolphin-gray text-lg font-bold mb-4 text-center`
export const DateTime = tw.p`font-display text-dolphin-gray tracking-widest mb-6 text-center`
export const Excerpt = styled.p`
	${tw`font-display mb-8`}
	display: -webkit-box;
  	-webkit-line-clamp: 4;
  	-webkit-box-orient: vertical;  
  	overflow: hidden;
`
export const Continue = tw.button`border-2 border-dolphin-gray hover:border-dolphin-gray bg-dolphin-gray hover:bg-transparent hover:text-dolphin-gray text-white py-2 px-6 rounded uppercase`
export const IndividualContainer = styled.div`
	${tw`grid lg:grid-cols-2 grid-cols-1 grid-flow-row gap-4`}
`
export const StoryContainer = styled.div`
${tw`flex flex-col w-full bg-white`}`
export const StoryTextContainer = tw.div`flex flex-col items-center p-3 h-full justify-between`
export const StoryTextDetails = tw.div`flex flex-col items-center`
export const StoryImage = styled.img`
	${tw`cursor-pointer hover:opacity-75`}
`

export const StoryImageContainer = styled.div`
	${tw`flex justify-center`}
	max-height: 300px;
`
export const StoriesSection = styled.section`
	${tw`flex flex-col md:flex-row w-full py-4 md:py-8 px-4 md:px-6`}

	> a {
		${tw`w-full md:w-3/12`}
	}

	> a:not(:last-of-type) {
		${tw`border-solid border-gray-500 border-b-2 md:border-r-2 md:border-b-0`}
	}
`
export const Story = tw.div`flex flex-col py-2 md:px-4`
export const StoriesCategory = tw.p`font-display uppercase text-gray-800 text-sm tracking-widest`
export const StoriesTitle = tw.p`font-bold text-dolphin-gray uppercase`

export const PopularSection = tw.section`py-4 md:py-12 w-full`
export const SectionTitle = tw.h2`font-display text-dolphin-gray text-3xl font-bold mb-8 text-center`
export const PostsContainer = styled.div`
	${tw`grid lg:grid-cols-3 grid-cols-1 lg:gap-2 gap-4 container lg:px-0 px-4`}`
export const PostsInner = styled.div`
	${tw`hover:opacity-75`}
`
export const DetailedPost = styled(Link)`
	${tw`flex flex-col p-4 md:p-16 items-center h-full justify-center border border-gray-300`}
	background-color: #eeeeee;
`
export const DetailedCategory = tw.p`font-display uppercase text-gray-800 mb-4 tracking-wider`
export const DetailedTtl = tw.h3`font-display text-dolphin-gray text-2xl font-bold mb-4 text-center`
export const DetailedDesc = tw.p`font-display text-center text-gray-700 leading-loose`
export const ShortPost = styled(Link)`
	${tw`flex flex-col items-center w-full bg-blue-600 relative border border-gray-300 hover:opacity-75 h-full`}
`
export const ShortPostImageContainer = styled.div`
	${tw`flex justify-center`}
`

export const ShortPostImage = styled.img``
export const ShortPostDetails = tw.div`p-4 md:p-8`
export const ShortPostTtl = tw.h3`font-display text-white text-2xl font-bold mb-4 text-center`
export const ShortPostCat = tw.p`font-display uppercase text-white mb-4 tracking-wider text-center`
